/**
* Scrolling Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'scrolling-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.scrolling-marquee' ).each( function( key, val ) {
        const items = $( this ).find( '.items' )[0];
        const width = $( items ).width();
        const fullWidth = items.scrollWidth;
        const scrollingWidth = ( fullWidth - width ) * -1;

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 75%',
            end: '300% 50%',
            scrub: 0,
            // markers: true,
          },
        } );
        tl.to( items, {x: scrollingWidth, ease: 'linear'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-marquee', COMPONENT );
} )( app );
